<template>
  <div class="consent-form">
    <div class="flash flash--error" v-if="error">
      <p v-text="error"></p>
    </div>

    <div class="checkbox" :class="{ checked: participant }" @click="toggle('participant')">
      <span v-html="templated_translations.consentParticipation"></span>
    </div>
    <div class="checkbox" v-if="participant" :class="{ checked: recontact }" @click="toggle('recontact')">
      <span v-html="templated_translations.consentRecontact"></span>
    </div>

    <call-to-action @click.native="save()" :processing="processing" v-text="translations.next"></call-to-action>
  </div>
</template>

<script>
import { get } from "lodash";
import { api } from "../utils";
import CallToAction from "./registration/CallToAction";
import { ERROR_GENERIC } from "../constants";
import HasTranslatedText from "../mixins/HasTranslatedText";

export default {
  mixins: [HasTranslatedText],

  data() {
    return {
      error: null,
      participant: false,
      recontact: false,
      processing: false,
    };
  },

  watch: {
    participant(v) {
      if (!v) {
        this.recontact = false;
      }
    },
  },

  computed: {
    templated_translations() {
      return {
        consentParticipation: this.translations.consentParticipation
          .replace("[[startBold]]", "<b>")
          .replace("[[endBold]]", "</b>"),
        consentRecontact: this.translations.consentRecontact
          .replace("[[startBold]]", "<b>")
          .replace("[[endBold]]", "</b>"),
      };
    },
  },

  methods: {
    toggle(attribute) {
      this[attribute] = !this[attribute];
    },

    async save() {
      this.error = null;
      this.processing = true;

      const payload = {
        field_metadata_study_participant: this.participant,
        field_metadata_study_recontact: this.recontact,
      };

      try {
        await api.patch("user", payload);

        window.location = get(window, "vueBridge.links.confirmationSent", "/confirmation-sent");
      } catch {
        this.error = ERROR_GENERIC;
      } finally {
        this.processing = false;
      }
    },
  },

  components: {
    CallToAction,
  },
};
</script>
